// extracted by mini-css-extract-plugin
export default {"icon":"Comment_icon__hvkYU","num":"Comment_num__w-Cyh","profileImage":"Comment_profileImage__l0st1","name":"Comment_name__eE6Yw","comment":"Comment_comment__cV-Re"};